import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import BaseValidator from 'services/validations/base-validator';
import AtLeastOneCombinationWasChosenValidator from 'components/organisms/nhl-team-stacking/validators/at-least-one-combination-was-chosen-validator';
import AtLeastOneTeamWasChosenForEachStackValidator from 'components/organisms/nhl-team-stacking/validators/at-least-one-team-was-chosen-for-each-stack-validator';
import AtLeastOneTeamWithExposureMoreThanZeroValidator from 'components/organisms/nhl-team-stacking/validators/at-least-one-team-with-exposure-more-than-zero-validator';
import MinExposureValidator from 'components/organisms/nhl-team-stacking/validators/min-exposure-validator';
import CombinationsMinExposureValidator from 'components/organisms/nhl-team-stacking/validators/combinations-min-exposure-validator';
import AtLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator from 'components/organisms/nhl-team-stacking/validators/at-least-one-line-or-pp-group-was-chosen-for-each-team-in-each-stack-validator';
import AtLeastOneCombinationWithExposureMoreThanZeroValidator from 'components/organisms/nhl-team-stacking/validators/at-least-one-combination-with-exposure-more-than-zero-validator';
import DefensemanExistsIfNeededValidator from 'components/organisms/nhl-team-stacking/validators/defenseman-exists-if-needed-validator';
import PlayersQuantityOfCheckedTeamsIsEnoughValidator from 'components/organisms/nhl-team-stacking/validators/players-quantity-of-checked-teams-is-enough-validator';

class NhlTeamStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            nhlTeamStacking: stacking,
            playersData: {preparedPlayers, lineGroupFilter},
        } = Action.getState();

        const validator = new BaseValidator();

        if (!stacking.isEnabled()) {
            return validator;
        }

        const atLeastOneCombinationWasChosenValidator = new AtLeastOneCombinationWasChosenValidator();
        atLeastOneCombinationWasChosenValidator.setDependencies({stacking});

        const atLeastOneTeamWasChosenForEachStackValidator = new AtLeastOneTeamWasChosenForEachStackValidator();
        atLeastOneTeamWasChosenForEachStackValidator.setDependencies({stacking});

        const atLeastOneTeamWithExposureMoreThanZeroValidator = new AtLeastOneTeamWithExposureMoreThanZeroValidator();
        atLeastOneTeamWithExposureMoreThanZeroValidator.setDependencies({stacking});

        const atLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator =
            new AtLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator();
        atLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator.setDependencies({stacking});

        const playersQuantityOfCheckedTeamsIsEnoughValidator = new PlayersQuantityOfCheckedTeamsIsEnoughValidator();
        playersQuantityOfCheckedTeamsIsEnoughValidator.setDependencies({
            stacking,
            playersGroupedByTeams: preparedPlayers.groupedBy.property('team'),
        });

        const defensemanExistsIfNeededValidator = new DefensemanExistsIfNeededValidator();
        defensemanExistsIfNeededValidator.setDependencies({
            stacking,
            playersGroupedByTeams: preparedPlayers.groupedBy.property('team'),
        });

        const minExposureValidator = new MinExposureValidator();
        minExposureValidator.setDependencies({stacking});

        const combinationsMinExposureValidator = new CombinationsMinExposureValidator();
        combinationsMinExposureValidator.setDependencies({stacking});

        const atLeastOneCombinationWithExposureMoreThanZeroValidator =
            new AtLeastOneCombinationWithExposureMoreThanZeroValidator();
        atLeastOneCombinationWithExposureMoreThanZeroValidator.setDependencies({stacking});

        validator.addSubValidators([
            atLeastOneCombinationWasChosenValidator,
            atLeastOneTeamWasChosenForEachStackValidator,
            atLeastOneTeamWithExposureMoreThanZeroValidator,
            atLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator,
            playersQuantityOfCheckedTeamsIsEnoughValidator,
            defensemanExistsIfNeededValidator,
            combinationsMinExposureValidator,
            minExposureValidator,
            atLeastOneCombinationWithExposureMoreThanZeroValidator,
        ]);

        return validator;
    }
}

export {NhlTeamStackingValidatorBuilder};
